module.exports = __webpack_public_path__ + "static/media/red_cheerleader.4394cf11.svg";